import React, { useContext } from "react";

// img
import avatar from "../../images/avatar.png";
import { toFarsiNumber } from "../../helper/helper";
import { UserData } from "../../contexts/UserInfoContext";

const ThemeFour = ({ data }) => {
  const { user, loaded } = useContext(UserData);

  const circle = [1, 2, 3, 4];
  return (
    <div className="relative flex min-w-[795px] max-w-[795px] h-auto border m-10">
      <div className="theme-four">
        <span></span>
      </div>
      {/* right side */}
      <div className="min-w-[300px] flex flex-col gap-10 pt-10 p-5 bg-indigo-50 min-h-full">
        <img
          src={
            data.user_info.avatar
              ? `https://api.myunibest.ir/${data.user_info.avatar}`
              : avatar
          }
          className="self-center w-56 h-56 object-cover z-10 relative border-8 border-indigo-50"
          alt=""
        />

        {/* اطلاعات */}
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-3">
            <div className="bg-indigo-500 w-8 h-8 flex items-center justify-center rounded-lg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-4 h-4 fill-white"
              >
                <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
                <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
              </svg>
            </div>

            <span>{data.user_info?.email}</span>
          </div>

          <div className="flex items-center gap-3">
            <div className="bg-indigo-500 w-8 h-8 flex items-center justify-center rounded-lg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-4 h-4 fill-white"
              >
                <path d="M10.5 18.75a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3z" />
                <path
                  fill-rule="evenodd"
                  d="M8.625.75A3.375 3.375 0 005.25 4.125v15.75a3.375 3.375 0 003.375 3.375h6.75a3.375 3.375 0 003.375-3.375V4.125A3.375 3.375 0 0015.375.75h-6.75zM7.5 4.125C7.5 3.504 8.004 3 8.625 3H9.75v.375c0 .621.504 1.125 1.125 1.125h2.25c.621 0 1.125-.504 1.125-1.125V3h1.125c.621 0 1.125.504 1.125 1.125v15.75c0 .621-.504 1.125-1.125 1.125h-6.75A1.125 1.125 0 017.5 19.875V4.125z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>

            <span>{toFarsiNumber(data.user.phone_number)}</span>
          </div>

          <div className="flex items-center gap-3">
            <div className="bg-indigo-500 w-8 h-8 flex items-center justify-center rounded-lg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-4 h-4 fill-white"
              >
                <path
                  fill-rule="evenodd"
                  d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>

            <span>
              {data.user_info?.province_id?.name},{" "}
              {data.user_info?.city_id?.name}, {data.user_info?.address}
            </span>
          </div>
        </div>

        {/* مهارت ها */}
        <div className="flex flex-col gap-4">
          <h2 className="font-medium text-lg">مهارت ها</h2>

          <div className="flex flex-col gap-3">
            {data.skills?.length > 0
              ? data.skills?.map((skill) => (
                  <div className="flex items-center justify-between text-sm">
                    <span>{skill.title}</span>

                    <div className="flex items-center gap-1">
                      {circle.map((item, i) =>
                        i + 1 <= Number(skill.level.code) ? (
                          <span className="w-4 h-4 bg-indigo-500 rounded-full"></span>
                        ) : (
                          <span className="size-4 rounded-full bg-indigo-200 block"></span>
                        )
                      )}
                    </div>
                  </div>
                ))
              : "مهارتی ثبت نشده است"}
          </div>
        </div>

        {/* زبان ها */}
        <div className="flex flex-col gap-4">
          <h2 className="font-medium text-lg">زبان</h2>
          {data.langs?.length > 0
            ? data.langs?.map((lang) => (
                <div className="w-full flex flex-col gap-3">
                  <h3 className="font-medium">{lang.title}</h3>

                  <div className="flex flex-col gap-3">
                    <div className="flex items-center justify-between text-sm">
                      <span>مهارت خواندن</span>
                      <div className="flex gap-1">
                        {circle.map((item, i) =>
                          i + 1 <= Number(lang.level.code) ? (
                            <span className="w-3 h-3 bg-indigo-500 rounded-full"></span>
                          ) : (
                            <span className="w-3 h-3 bg-indigo-200 rounded-full"></span>
                          )
                        )}
                      </div>
                    </div>

                    <div className="flex items-center justify-between text-sm">
                      <span>مهارت نوشتن</span>
                      <div className="flex gap-1">
                        {circle.map((item, i) =>
                          i + 1 <= Number(lang.level.code) ? (
                            <span className="w-3 h-3 bg-indigo-500 rounded-full"></span>
                          ) : (
                            <span className="w-3 h-3 bg-indigo-200 rounded-full"></span>
                          )
                        )}
                      </div>
                    </div>

                    <div className="flex items-center justify-between text-sm">
                      <span>مهارت گفتاری</span>
                      <div className="flex gap-1">
                        {circle.map((item, i) =>
                          i + 1 <= Number(lang.level.code) ? (
                            <span className="w-3 h-3 bg-indigo-500 rounded-full"></span>
                          ) : (
                            <span className="w-3 h-3 bg-indigo-200 rounded-full"></span>
                          )
                        )}
                      </div>
                    </div>

                    <div className="flex items-center justify-between text-sm">
                      <span>مهارت شنیداری</span>
                      <div className="flex gap-1">
                        {circle.map((item, i) =>
                          i + 1 <= Number(lang.level.code) ? (
                            <span className="w-3 h-3 bg-indigo-500 rounded-full"></span>
                          ) : (
                            <span className="w-3 h-3 bg-indigo-200 rounded-full"></span>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            : "زبان ثبت نشده است"}
        </div>
      </div>

      {/* left side */}
      <div className="flex flex-col gap-5 p-5 pt-10">
        <div className="flex flex-col gap-2">
          <h1 className="text-2xl font-medium">
            {data.user.name + " " + data.user.family_name}
          </h1>
          <span className="font-medium text-gray-600 block mb-3">
            {data.job_info?.title}
          </span>
          <span className="line text-sm relative pr-5">
            متولد : {toFarsiNumber(data.user_info.birth)}
          </span>
          <span className="line text-sm relative pr-5">
            وضعیت سربازی : {data.basic_info?.army?.name}
          </span>
          <span className="line text-sm relative pr-5">
            وضعیت تاهل : {data.basic_info?.in_rell?.name}
          </span>
        </div>

        {/* خلاصه رزومه */}
        <div className="flex flex-col gap-3 mt-32">
          <div className="flex items-center gap-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="w-6 h-6 fill-indigo-500"
            >
              <path
                fill-rule="evenodd"
                d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z"
                clip-rule="evenodd"
              />
            </svg>
            <span className="font-medium text-[17px]">خلاصه رزومه</span>
          </div>

          <p className="text-sm leading-7">{data.description}</p>
        </div>

        {/* سوابق تحصیلی */}
        <div className="flex flex-col gap-3 mt-5">
          <div className="flex items-center gap-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="w-6 h-6 fill-indigo-500"
            >
              <path d="M11.7 2.805a.75.75 0 01.6 0A60.65 60.65 0 0122.83 8.72a.75.75 0 01-.231 1.337 49.949 49.949 0 00-9.902 3.912l-.003.002-.34.18a.75.75 0 01-.707 0A50.009 50.009 0 007.5 12.174v-.224c0-.131.067-.248.172-.311a54.614 54.614 0 014.653-2.52.75.75 0 00-.65-1.352 56.129 56.129 0 00-4.78 2.589 1.858 1.858 0 00-.859 1.228 49.803 49.803 0 00-4.634-1.527.75.75 0 01-.231-1.337A60.653 60.653 0 0111.7 2.805z" />
              <path d="M13.06 15.473a48.45 48.45 0 017.666-3.282c.134 1.414.22 2.843.255 4.285a.75.75 0 01-.46.71 47.878 47.878 0 00-8.105 4.342.75.75 0 01-.832 0 47.877 47.877 0 00-8.104-4.342.75.75 0 01-.461-.71c.035-1.442.121-2.87.255-4.286A48.4 48.4 0 016 13.18v1.27a1.5 1.5 0 00-.14 2.508c-.09.38-.222.753-.397 1.11.452.213.901.434 1.346.661a6.729 6.729 0 00.551-1.608 1.5 1.5 0 00.14-2.67v-.645a48.549 48.549 0 013.44 1.668 2.25 2.25 0 002.12 0z" />
              <path d="M4.462 19.462c.42-.419.753-.89 1-1.394.453.213.902.434 1.347.661a6.743 6.743 0 01-1.286 1.794.75.75 0 11-1.06-1.06z" />
            </svg>

            <span className="font-medium text-[17px]">سوابق تحصیلی</span>
          </div>

          <div className="grid grid-cols-2 text-gray-600">
            {data.edu_info?.length > 0
              ? data.edu_info?.map((edu) => (
                  <div className="flex flex-col gap-2 text-xs">
                    <h2 className="text-sm font-semibold text-gray-800">
                      {edu.title}
                    </h2>
                    <span>مقطع تحصیلی: {edu.grade.name}</span>
                    <span>موسسه/دانشگاه: {edu.college_name}</span>
                  </div>
                ))
              : "اطلاعات تحصیلی ثبت نشده!"}
          </div>
        </div>

        {/* سوابق شغلی */}
        <div className="flex flex-col gap-3 mt-5">
          <div className="flex items-center gap-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="size-6 fill-indigo-500"
            >
              <path
                fill-rule="evenodd"
                d="M7.5 5.25a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v.205c.933.085 1.857.197 2.774.334 1.454.218 2.476 1.483 2.476 2.917v3.033c0 1.211-.734 2.352-1.936 2.752A24.726 24.726 0 0 1 12 15.75c-2.73 0-5.357-.442-7.814-1.259-1.202-.4-1.936-1.541-1.936-2.752V8.706c0-1.434 1.022-2.7 2.476-2.917A48.814 48.814 0 0 1 7.5 5.455V5.25Zm7.5 0v.09a49.488 49.488 0 0 0-6 0v-.09a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5Zm-3 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
                clip-rule="evenodd"
              />
              <path d="M3 18.4v-2.796a4.3 4.3 0 0 0 .713.31A26.226 26.226 0 0 0 12 17.25c2.892 0 5.68-.468 8.287-1.335.252-.084.49-.189.713-.311V18.4c0 1.452-1.047 2.728-2.523 2.923-2.12.282-4.282.427-6.477.427a49.19 49.19 0 0 1-6.477-.427C4.047 21.128 3 19.852 3 18.4Z" />
            </svg>

            <span className="font-medium text-[17px]">سوابق شغلی</span>
          </div>

          <div className="grid grid-cols-1 text-gray-600 gap-3">
            {data.past_jobs?.length > 0
              ? data.past_jobs?.map((job) => (
                  <div className="flex flex-col gap-2 text-xs">
                    <h2 className="text-sm font-semibold text-gray-800">
                      {job.title}
                    </h2>
                    <span>نام شرکت: {job.company_name}</span>

                    <span>
                      {job.start_date
                        ? new Intl.DateTimeFormat("fa-IR", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          }).format(new Date(job.start_date))
                        : "ثبت نشده"}{" "}
                      -{" "}
                      {job.end_date && !job.working
                        ? new Intl.DateTimeFormat("fa-IR", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          }).format(new Date(job.end_date))
                        : "مشغول به کار"}
                    </span>

                    <p className="pl-3">{job.description}</p>
                  </div>
                ))
              : "سوابق شغلی ثبت نشده"}
          </div>
        </div>

        {/* دوره ها و گواهینامه ها */}
        <div className="flex flex-col gap-3 mt-5">
          <div className="flex items-center gap-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="size-6 fill-indigo-500"
            >
              <path d="M7.5 3.375c0-1.036.84-1.875 1.875-1.875h.375a3.75 3.75 0 0 1 3.75 3.75v1.875C13.5 8.161 14.34 9 15.375 9h1.875A3.75 3.75 0 0 1 21 12.75v3.375C21 17.16 20.16 18 19.125 18h-9.75A1.875 1.875 0 0 1 7.5 16.125V3.375Z" />
              <path d="M15 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 17.25 7.5h-1.875A.375.375 0 0 1 15 7.125V5.25ZM4.875 6H6v10.125A3.375 3.375 0 0 0 9.375 19.5H16.5v1.125c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 0 1 3 20.625V7.875C3 6.839 3.84 6 4.875 6Z" />
            </svg>

            <span className="font-medium text-[17px]">
              دوره ها و گواهینامه ها
            </span>
          </div>

          <div className="grid grid-cols-1 text-gray-600 gap-3">
            {data.courses?.length > 0
              ? data.courses?.map((course) => (
                  <div className="flex flex-col gap-2 text-xs">
                    <h2 className="text-sm font-semibold text-gray-800">
                      {course.title}
                    </h2>
                    <span>
                      {course.start_date
                        ? new Intl.DateTimeFormat("fa-IR", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          }).format(new Date(course.start_date))
                        : "ثبت نشده"}{" "}
                      -{" "}
                      {course.end_date && !course.working
                        ? new Intl.DateTimeFormat("fa-IR", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          }).format(new Date(course.end_date))
                        : "دوره درحال برگذاری است"}
                    </span>

                    <p className="pl-3">{course.description}</p>
                  </div>
                ))
              : "سوابق شغلی ثبت نشده"}
          </div>
        </div>

        {/* پروژه ها */}
        <div className="flex flex-col gap-3 mt-5">
          <div className="flex items-center gap-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="size-6 fill-indigo-500"
            >
              <path d="M7.5 3.375c0-1.036.84-1.875 1.875-1.875h.375a3.75 3.75 0 0 1 3.75 3.75v1.875C13.5 8.161 14.34 9 15.375 9h1.875A3.75 3.75 0 0 1 21 12.75v3.375C21 17.16 20.16 18 19.125 18h-9.75A1.875 1.875 0 0 1 7.5 16.125V3.375Z" />
              <path d="M15 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 17.25 7.5h-1.875A.375.375 0 0 1 15 7.125V5.25ZM4.875 6H6v10.125A3.375 3.375 0 0 0 9.375 19.5H16.5v1.125c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 0 1 3 20.625V7.875C3 6.839 3.84 6 4.875 6Z" />
            </svg>

            <span className="font-medium text-[17px]">پروژه ها</span>
          </div>

          <div className="flex flex-col gap-5 text-gray-600">
            {data.projects?.length > 0
              ? data.projects?.map((project) => (
                  <div className="flex flex-col gap-2 text-xs">
                    <h2 className="text-sm font-semibold text-gray-800">
                      {project.title}
                    </h2>
                    <span>
                      {project.start_date
                        ? new Intl.DateTimeFormat("fa-IR", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          }).format(new Date(project.start_date))
                        : "ثبت نشده"}{" "}
                      -{" "}
                      {project.end_date && !project.working
                        ? new Intl.DateTimeFormat("fa-IR", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          }).format(new Date(project.end_date))
                        : "درحال انجام"}
                    </span>

                    <p className="text-sm">{project.description}</p>
                    <div className="flex items-center gap-2">
                      <span>لینک :</span>
                      <a
                        href={project.link}
                        target="_blank"
                        className="text-indigo-600 underline"
                      >
                        {project.link}
                      </a>
                    </div>
                  </div>
                ))
              : "پروژه ای ثبت نشده است"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThemeFour;
